import React from 'react';
import Route from 'react-router-dom/es/Route';

export default ({ component, ...rest }) => {
  const renderMergedProps = (Component, rest) => {
    const finalProps = { ...rest };
    return <Component {...finalProps} />;
  };

  return (
    <Route
      {...rest}
      render={routeProps => {
        return renderMergedProps(component, { ...routeProps, ...rest });
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/wrappers/props-route.js